"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Twitter, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-5 w-16 bg-secondary/20 animate-pulse rounded-md" />
        <div className="h-5 w-24 bg-secondary/20 animate-pulse rounded-md" />
        <div className="h-5 w-16 bg-secondary/20 animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-foreground-primary text-sm font-medium hover:text-secondary transition-colors duration-100 hover:underline underline-offset-4">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="w-full bg-primary text-foreground-primary py-6 px-4 md:px-8" style={{
    boxShadow: "inset 0 2px 8px rgba(0,0,0,0.12), 0 1px 3px rgba(0,0,0,0.08)"
  }}>
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        {}
        <div className="text-sm text-foreground-primary/90">
          © {currentYear} Screenado. All rights reserved.
        </div>

        {}
        <div className="flex items-center gap-8">
          <MenuProvider menu_id="3">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex items-center gap-4">
            <Link to="https://facebook.com" newTab className="text-foreground-primary hover:text-secondary transition-colors duration-100" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://twitter.com" newTab className="text-foreground-primary hover:text-secondary transition-colors duration-100" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="https://instagram.com" newTab className="text-foreground-primary hover:text-secondary transition-colors duration-100" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}